import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './auth';
const ConfigContext = createContext({});

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  const { id_empresa } = useAuth();

  const updateConfig = (newConfig) => {
    setConfig((prevConfig) => ({
      ...prevConfig,
      ...newConfig,
    }));
  };

  useEffect(() => {
    if (id_empresa) {
      api
        .get(`configuracao/encontrar/${id_empresa}`)
        .then((res) => {
          setConfig(res.data);
        })
        .catch((error) => console.log({ error }));
    }
  }, [id_empresa]);

  return (
    <ConfigContext.Provider value={{ config, updateConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export function useConfig() {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error('ConfigContext must be used within an ConfigContext');
  }
  return context;
}
